module.exports = __webpack_public_path__ + "static/media/loading-icon.64d601b4.gif";